﻿import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";

export default class TemplatedDocumentRenderer {
	constructor() {
		this.parser = new DOMParser();
	}

	canRender(document) {
		const extensions = ["docx", "DOCX", "pdf", "PDF", "doc", "DOC"];

		return extensions.includes(document.extension);
	}

	getTemplate() {
		if (!this.template) {
			const template = document.getElementById("document-template").innerHTML;
			this.template = underscoreTemplateGrindex(template);
		}

		return this.template;
	}

	render(doc) {
		const docMarkup = this.getTemplate()(doc);

		const $doc = this.parser.parseFromString(docMarkup, "text/html").querySelector("body");

		return Array.prototype.filter.call($doc.childNodes, ($node) => {
			return $node.tagName === "LI";
		})[0];
	}
}
